module.exports = __webpack_public_path__ + "img/jingyu.005f54b5.png";